import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Flex } from '../../common';
import { useCartStore } from '@/store';
import { useThemeToken } from '@/hooks';
import { MessageInstance } from 'antd/es/message/interface';
import { useAppContext, useSelfContext } from '@/context';
import { envConfig } from '@/configs';
import ReserveActionButtons from './ReserveActionButtons';
import getParsedPriceFromFood from '@/utils/getParsedPrice';
import { useTranslation } from 'react-i18next';
import { getCombinedDisplayCount } from './reserveDisplayCounts';

export interface ReserveCardProps {
  panelWeekStartDate?: string;
  isNewReserveMode?: boolean;
  meal: SelfMealEntity;
  reserve: UserWeekReserveEntity;
  messageAPI: MessageInstance;
  onChangeSelf: () => void;
  onDetailClick: () => void;
  locked: boolean;
  setLocked: (value: boolean) => any;
}

export default function ReserveCard({
  isNewReserveMode = false,
  panelWeekStartDate,
  reserve,
  meal,
  messageAPI,
  onDetailClick,
  onChangeSelf,
  locked,
  setLocked
}: ReserveCardProps) {

  const [t] = useTranslation(['common', 'reserve']);
  const { mode } = useAppContext();
  const { currentSelf } = useSelfContext();
  const cartPrograms = useCartStore(s => s.programs);
  const freeRestaurant = Boolean(currentSelf?.freeRestaurant);
  const [selectedCount, setSelectedCount] = useState(() => {
    if (freeRestaurant) {
      return getCombinedDisplayCount(reserve, cartPrograms);
    }
    const basketItem = cartPrograms.find(p => p.id === reserve.programId);
    return (reserve.selectedCount || 0) + (basketItem?.selectedCount || 0);
  });
  // const reserveItemProps = useReserveItem({ meal, food });

  const { colorPrimary, colorPrimaryDarker, colorPrimaryLight } = useThemeToken();

  const isActive = selectedCount > 0;
  const styles = isActive ? {
    backgroundColor: colorPrimaryLight,
    border: `2px solid ${colorPrimary}`
  } : { border: '2px solid transparent' };

  useEffect(() => {
    if (!freeRestaurant) return;
    setSelectedCount(getCombinedDisplayCount(reserve, cartPrograms));
  }, [freeRestaurant, cartPrograms, reserve?.programId, reserve?.id, reserve?.selectedCount]);

  if (reserve.hideInPanel) return <></>;

  return (
    <Flex
      gap={6}
      style={styles}
      className={classNames('program-reserve-item', { 'program-reserve-item-active': isActive })} direction="column">
      <Flex align="center">
        <span style={{ color: colorPrimaryDarker }} className="font-bold text-sm">{meal.mealTypeName}</span>
        {!envConfig.ui.removePrices && (
          <span className="item-price">{getParsedPriceFromFood(reserve, t)}</span>
        )}
      </Flex>
      <span className="item-name">
        {reserve?.foodNames}
      </span>
      {mode === 'transport' && (
        <span className="text-xs text-center">{reserve?.foodTypeTitle}</span>
      )}
      {!reserve.hideBesideFoodInPanel && mode === 'health' && (
        <span className="text-xs text-center">{reserve?.besideFoodNames}</span>
      )}
      {mode === 'health' && reserve?.foodTypeTitle && (
        <span className="text-xs text-center">
          {reserve.foodTypeTitle}
        </span>
      )}
      <Flex direction="column" className="mt-auto">
        <div
          className="more-detail"
          onClick={onDetailClick}>
          {t('common:labels.more-details')}
        </div>
        <ReserveActionButtons
          isNewReserveMode={isNewReserveMode}
          panelWeekStartDate={panelWeekStartDate}
          meal={meal}
          reserve={reserve}
          messageAPI={messageAPI}
          onChangeSelf={onChangeSelf}
          selectedCount={selectedCount}
          setSelectedCount={setSelectedCount}
          locked={locked}
          setLocked={setLocked}
        />
      </Flex>
    </Flex>
  );
}
